import { Star } from "lucide-react";

const stats = [
  { id: "homes", value: "150+", label: "Homes Sold" },
  { id: "years", value: "15", label: "Years Experience" },
  { id: "stars", value: "", label: "5-Star Reviews", isStar: true },
  { id: "range", value: "$138K–$1.5M", label: "Price Range" },
];

export default function StatsBar() {
  return (
    <section className="py-16 bg-[#0A0A0A] border-y border-[#D4AF37]/20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat) => (
            <div key={stat.id} className="text-center space-y-2" data-testid={`stat-${stat.id}`}>
              {stat.isStar ? (
                <div className="flex items-center justify-center gap-1">
                  {[1, 2, 3, 4, 5].map((n) => (
                    <Star key={`star-${n}`} className="w-7 h-7 md:w-9 md:h-9 fill-[#D4AF37] text-[#D4AF37]" />
                  ))}
                </div>
              ) : (
                <p className="text-4xl md:text-5xl font-black text-[#D4AF37]">{stat.value}</p>
              )}
              <p className="text-zinc-400 uppercase tracking-wider text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
